<template>
<div>
  <el-button style="width:100%;" size="small" type="secondary" @click="openPopup">시뮬레이션 예측</el-button>
  <w-simulation-predict-popup ref="popup" />
</div>
</template>

<script>
import clone from 'lodash/clone';
import WSimulationPredictPopup from './SimulationPredictPopup';

export default {
  name: 'WSimulationPredictPopupButton',
  components: {
    WSimulationPredictPopup,
  },
  props: {
    obj: {
      type: Object,
    },
  },
  methods: {
    openPopup() {
      const obj = clone(this.obj.obj);
      obj.ipaddress = this.obj.ipaddress;
      this.$refs.popup.open(obj);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/button/common/SimulationPredictPopupButton/index.vue